import { UpsertComponentRequest } from '../WebApiClient';

export class ComponentStatus {
    copy(): ComponentStatus {
        let result = new ComponentStatus(new UpsertComponentRequest(this.request), this.status);
        result.status = this.status;
        return result;
    }
    constructor(request: UpsertComponentRequest, status: 'unchanged' | 'changedOrNew' | 'deleted') {
        this.request = request;
        this.status = status;
    }
    request: UpsertComponentRequest;
    status: 'unchanged' | 'changedOrNew' | 'deleted';

    get name() { return this.request.description; }

    get isValid() { return this.status !== 'changedOrNew' || !!this.request.description; }
}
